var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-edit-container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "left-panel",
            _vm._g(
              _vm._b(
                { ref: "leftBorad" },
                "left-panel",
                {
                  activeData: _vm.activeData,
                  formConf: _vm.tempFormConf,
                  formKey: _vm.formKey,
                },
                false
              ),
              {
                "clone-component": _vm.cloneComponent,
                move: _vm.handleMove,
                end: _vm.onEnd,
                "add-component": _vm.addComponent,
                "scroll-to": _vm.scrollToItem,
                outlineEnd: _vm.onOutlineEnd,
                start: _vm.onStart,
                deleteManyProjectItem: _vm.deleteManyProjectItem,
              }
            )
          ),
          _c(
            "div",
            { staticClass: "center-board" },
            [
              _c(
                "el-row",
                {
                  staticClass: "operation-btn-view",
                  attrs: { type: "flex", align: "middle" },
                },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "text-base-color small-font-size",
                      attrs: { span: 12 },
                    },
                    [
                      _vm._v(" * 表单内容自动保存 "),
                      _c("i", {
                        class: _vm.showLoading
                          ? "el-icon-loading"
                          : "el-icon-check",
                      }),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "import-topic-box", attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left", type: "text" },
                          on: { click: _vm.handleUndo },
                        },
                        [_vm._v(" 撤销 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-top", type: "text" },
                          on: { click: _vm.handleOpenImportItem },
                        },
                        [_vm._v(" 导入题目 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("ImportFormItem", {
                ref: "importItems",
                attrs: { "form-key": _vm.formKey },
                on: { success: _vm.handleConfirmImport },
              }),
              _c(
                "el-scrollbar",
                {
                  ref: "centerScrollbar",
                  staticClass: "form-center-scrollbar",
                },
                [
                  _c(
                    "center-panel",
                    _vm._g(
                      _vm._b(
                        {
                          ref: "centerBorad",
                          attrs: {
                            activeId: _vm.activeId,
                            drawingList: _vm.drawingList,
                            activeGroupId: _vm.activeGroupId,
                            currenGroupItem: _vm.currenGroupItem,
                            operate: _vm.operate,
                          },
                          on: {
                            "update:activeId": function ($event) {
                              _vm.activeId = $event
                            },
                            "update:active-id": function ($event) {
                              _vm.activeId = $event
                            },
                            "update:drawingList": function ($event) {
                              _vm.drawingList = $event
                            },
                            "update:drawing-list": function ($event) {
                              _vm.drawingList = $event
                            },
                            "update:activeGroupId": function ($event) {
                              _vm.activeGroupId = $event
                            },
                            "update:active-group-id": function ($event) {
                              _vm.activeGroupId = $event
                            },
                            "update:currenGroupItem": function ($event) {
                              _vm.currenGroupItem = $event
                            },
                            "update:curren-group-item": function ($event) {
                              _vm.currenGroupItem = $event
                            },
                            "update:operate": function ($event) {
                              _vm.operate = $event
                            },
                          },
                        },
                        "center-panel",
                        _vm.centerProps,
                        false
                      ),
                      _vm.centerEvents
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("right-panel", {
            attrs: {
              "active-data": _vm.activeData,
              activeGroupId: _vm.activeGroupId,
              "form-conf": _vm.formConf,
              fields: _vm.drawingList,
              "show-field": !!_vm.drawingList.length,
              formKey: _vm.formKey,
            },
            on: {
              "tag-change": _vm.tagChange,
              "add-fields": _vm.handleAddFields,
              "data-change": _vm.handleActiveDataChange,
              "other-required-change": _vm.handleChangeRequired,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "create-form-dialog",
          attrs: { visible: _vm.formItemExtensionVisible, width: "35%" },
          on: {
            "update:visible": function ($event) {
              _vm.formItemExtensionVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("h2", [_vm._v("选项后填空")]),
              _c("span", { staticClass: "title_tips" }, [
                _vm._v("在选项后设置填空，供答题者补充答题信息"),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.extensionData },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "选项", prop: "label" },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c("span", { staticStyle: { display: "none" } }, [
                              _vm._v(_vm._s(scope.row)),
                            ]),
                            _c(
                              "el-checkbox",
                              {
                                on: {
                                  change: function (val) {
                                    return _vm.handleClickRequire(val, "isFill")
                                  },
                                },
                                model: {
                                  value: _vm.isFillChecked,
                                  callback: function ($$v) {
                                    _vm.isFillChecked = $$v
                                  },
                                  expression: "isFillChecked",
                                },
                              },
                              [_vm._v(" 设置填空 ")]
                            ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "line-height": "1",
                                },
                              },
                              [
                                _c("el-checkbox", {
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: { disabled: row.value === 0 },
                                  on: {
                                    change: function ($event) {
                                      return _vm.resetOptionExtension(row.value)
                                    },
                                  },
                                  model: {
                                    value: row.isFill,
                                    callback: function ($$v) {
                                      _vm.$set(row, "isFill", $$v)
                                    },
                                    expression: "row.isFill",
                                  },
                                }),
                                row.isFill
                                  ? _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "drawing-item__setting",
                                            attrs: { title: "选项后填空" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSetting(
                                                  row.value
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-setting",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: row.fillContent,
                                                    expression:
                                                      "row.fillContent",
                                                  },
                                                ],
                                                staticClass:
                                                  "drawing-item__check",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" 填空内容可选择 "),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c("span", { staticStyle: { display: "none" } }, [
                              _vm._v(_vm._s(scope.row)),
                            ]),
                            _c(
                              "el-checkbox",
                              {
                                on: {
                                  change: function (val) {
                                    return _vm.handleClickRequire(
                                      val,
                                      "required"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.requiredChecked,
                                  callback: function ($$v) {
                                    _vm.requiredChecked = $$v
                                  },
                                  expression: "requiredChecked",
                                },
                              },
                              [_vm._v(" 是否必填 ")]
                            ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              model: {
                                value: scope.row.required,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "required", $$v)
                                },
                                expression: "scope.row.required",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.formItemExtensionVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.batchDialogVisible, width: "30%" },
          on: {
            "update:visible": function ($event) {
              _vm.batchDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("h2", [_vm._v("填空内容可选择")]),
              _c("span", { staticClass: "title_tips" }, [
                _vm._v(
                  "若想让答题者在可填空的输入框中进行下拉选择，可以在下方输入框中输入选项，一行一个。"
                ),
              ]),
            ]
          ),
          _c("span", { staticClass: "desc-text" }, [
            _vm._v("每行对应一个选项"),
          ]),
          _c("el-input", {
            attrs: {
              type: "textarea",
              autosize: { minRows: 10, maxRows: 5000 },
              placeholder: "选项1 选项2  选项3 ",
            },
            model: {
              value: _vm.batchItemValue,
              callback: function ($$v) {
                _vm.batchItemValue = $$v
              },
              expression: "batchItemValue",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      ;(_vm.batchDialogVisible = false),
                        (_vm.batchItemValue = "")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.batchEditSelectItems },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }